<template>
  <el-dialog title="完善出车安排" :append-to-body="true" :visible.sync="showTag" width="30%">
    <el-form :model="form" label-width="100px" size="mini" ref="form" :rules="rules">
      <template v-if="aspectUser==='accept'">
        <el-form-item label="转诊时间" prop="referralTime">
          <el-date-picker type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                          v-model="form.referralTime" :picker-options="{disabledDate}"></el-date-picker>
        </el-form-item>
        <el-form-item label="主管医生" prop="directorDoc">
          <el-input v-model="form.directorDoc"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="directorDocMobile">
          <el-input v-model="form.directorDocMobile"></el-input>
        </el-form-item>
      </template>

      <template v-if="showJhcItem">
        <el-form-item label="救护车" prop="emergencyAmbulanceId">
          <el-select v-model="form.emergencyAmbulanceId" filterable placeholder="请选择">
            <el-option v-for="(item,index) in carList" :label="item.ambulanceName" :value="item.id"
                       :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="司机" prop="aid_driver">
          <el-select v-model="form.aid_driver" filterable placeholder="请选择">
            <el-option v-for="(item,index) in driverList" :key="index" :label="item.staffName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="急救医生" prop="doc">
          <el-select v-model="form.doc" filterable placeholder="请选择">
            <el-option v-for="(item,index) in docList" :key="index" :label="item.docName"
                       :value="item.emergencyPersonnelId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="index===0?'急救护士':''" v-for="(data,index) in form.nurse" :key="index">
          <el-select v-model="form.nurse[index]" filterable placeholder="请选择">
            <el-option v-for="(item,index) in showNurseList" :key="index" :label="item.docName"
                       :value="item.emergencyPersonnelId" :disabled="item.disabled"></el-option>
          </el-select>
          <span class="color_red ml5 pointer" @click.prevent="remove(index)" v-if="index>0">删除</span>
        </el-form-item>
        <el-form-item label="">
          <el-button type="text" size="mini" @click="add">+增加</el-button>
        </el-form-item>
      </template>
      <el-form-item label="转运注意事项">
        <el-input type="textarea" v-model="form.transportCarefulMatter"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input type="textarea" v-model="form.remark"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="hide" size="mini">取 消</el-button>
      <el-button type="primary" @click="sub" size="mini" :loading="appShowLoading">确认安排</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {staffService} from "../service/staff";
import {USER_TYPE} from "../../../common/lib/config";
import {STAFF_PROCESS_ORDER_SUCCESS} from "../events";
import {isEmpty} from "../../../common/lib/utils";
import {timeFilter} from "../../../common/lib/filters";
import {disabledDate} from "../filter";

export default {
  name: "perfect-car-dialog",
  props: {
    aspectUser: String
  },
  data() {
    return {
      docList: [],
      nurseList: [],
      carList: [],
      driverList: [],
      showTag: false,
      form: {
        nurse: [''],
      },

      rules: {
        referralTime: [
          {required: true, message: '请选择转诊时间', trigger: 'blur'}
        ],
        directorDoc: [
          {required: true, message: '请填写主管医生', trigger: 'blur'}
        ],
        directorDocMobile: [
          {required: true, message: '请填写联系方式', trigger: 'blur'}
        ],
        /*emergencyAmbulanceId: [
          {required: true, message: '请选择救护车', trigger: 'blur'}
        ],
        aid_driver: [
          {required: true, message: '请选择司机', trigger: 'blur'}
        ],
        doc: [
          {required: true, message: '请选择医生', trigger: 'blur'}
        ]*/
      },

      info: {}
    }
  },
  computed: {
    showJhcItem() {
      const {aspectUser, form} = this;
      if (aspectUser === 'accept' && ['SUB_HOSPITAL_AMBULANCE', 'THIRD_PARTY_AMBULANCE'].includes(form.dispatchingCarType)) return false;
      return true;
    },
    showNurseList() {
      return this.nurseList.map(r => {
        if (this.form.nurse.includes(r.emergencyPersonnelId)) {
          r.disabled = true;
        } else {
          r.disabled = false;
        }
        return r;
      });
    }
  },
  methods: {
    disabledDate,
    show(info) {
      this.info = info;
      this.showTag = true;
      this.setForm();
      this.getCar();
      this.getDriver();
      this.getDoc();
      this.getNurse();
    },
    hide() {
      this.showTag = false;
    },
    add() {
      this.form.nurse.push('');
    },
    remove(index) {
      this.form.nurse.splice(index, 1);
    },
    setForm() {
      const {info} = this;
      if (!isEmpty(info)) {
        info.referralTime && this.$set(this.form, 'referralTime', timeFilter(info.referralTime, 'YYYY-MM-DD HH:mm:ss'));
        this.form.nurse.splice(0);
        if (info.emergencyStaffingList && info.emergencyStaffingList.length) {
          info.emergencyStaffingList.forEach(r => {
            ['aid_driver', 'doc'].forEach(rr => {
              if (rr.toUpperCase() === r.emergencyPersonnelType) {
                this.$set(this.form, rr, r.emergencyPersonnelId);
              }
            })
            if (r.emergencyPersonnelType === 'nurse'.toUpperCase()) {
              this.form.nurse.push(r.emergencyPersonnelId)
            }
          });
        }
        if (this.form.nurse.length === 0) this.form.nurse.push('');
        ['remark', 'transportCarefulMatter', 'directorDoc', 'directorDocMobile', 'emergencyAmbulanceId', 'dispatchingCarType'].forEach(r => {
          info[r] && this.$set(this.form, r, info[r]);
        });
      }
    },
    async getCar() {
      this.carList = await staffService.listCarNoPage();
    },
    async getDriver() {
      this.driverList = await staffService.listDriverNoPage();
    },
    async getDoc() {
      this.docList = await staffService.listDocNoPage(USER_TYPE.DOC.id);
    },
    async getNurse() {
      this.nurseList = await staffService.listDocNoPage(USER_TYPE.NURSE.id);
    },

    validate() {
      console.log('validate------------------')
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          console.log('valid------------', valid);
          if (valid) resolve(true);
          else reject(false)
        })
      })

    },

    async sub() {

      const valid = await this.validate().catch(() => false);
      if (!valid) return;

      const {info} = this;
      const form = {...this.form};
      form.dispatchingCarType = info.dispatchingCarType;
      form.staffingList = [];
      ['aid_driver', 'doc'].forEach(r => {
        if (form[r]) {
          form.staffingList.push({
            emergencyPersonnelId: form[r],
            emergencyPersonnelType: r.toUpperCase()
          });
          delete form[r];
        }
      });
      if (form.nurse && form.nurse.length && form.nurse.some(r => !isEmpty(r))) {
        form.nurse.forEach(r => {
          r && form.staffingList.push({
            emergencyPersonnelId: r,
            emergencyPersonnelType: 'nurse'.toUpperCase()
          })
        });
        delete form.nurse;
      }
      if (form.staffingList.length === 0) delete form.staffingList;
      if (await staffService.perfectOrder({
        orderId: this.info.id,
        ...form
      })) {
        this.hide();
        this.$message.success({
          message: '操作成功',
          onClose: () => {
            bus.$emit(STAFF_PROCESS_ORDER_SUCCESS.id, 0);
          }
        })
      }
    }
  },
}
</script>

<style scoped>
</style>
